import $ from 'jquery';
import authentication from '../customeraccount/authentication';

const mobileAlert = {
    _bindEvents: function () {
        $('body')
            .on(
                'click',
                '#saveSMS',
                function (e) {
                    e.preventDefault();
                    this._saveForm($(e.target));
                }.bind(this)
            )
            .on('click', '#OptInToSms', function () {
                $('.mobileNum').toggle();
            })
            .on(
                'click',
                '#SaveMyInformation',
                function () {
                    this._smsNumberAvailable();
                }.bind(this)
            );
    },

    _smsNumberAvailable: function () {
        var $opt = $('#OptInToSms'),
            $num = $('.mobileNum'),
            isChecked = $opt.prop('checked');

        $('.smsMsg').toggle();
        $('#SmsPhoneNumber').prop('disabled', isChecked);

        if (isChecked) {
            $opt.prop('checked', !isChecked);
            $num.hide();
        }
    },

    _smsCheck: function () {
        var $mobile = $('.mobileNum'),
            $sms = $('#OptInToSms'),
            $msg = $('#smsMsg'),
            $saveInfo = $('#SaveMyInformation');

        if ($saveInfo.prop('checked')) {
            $msg.toggle();
        }

        if ($sms.prop('checked')) {
            $mobile.toggle();
        }
    },

    _saveForm: function ($element) {
        var $form = $element.closest('.smsOptInEdit');

        this._authenticateAndSave($form);
    },

    _authenticateAndSave: function ($element) {
        function onSuccess(result) {
            if (result.Redirect) {
                location.href = result.Redirect;
                return;
            }

            var $content = $(result);

            $element.replaceWith($content);
            mobileAlert._smsCheck();
        }

        function authenticatedTask() {
            var $form = $element.find('form'),
                url = $element.find('.submit_url').val(),
                formData = $form.serialize();

            $.post(url, formData).done(onSuccess);
        }

        authentication.checkReAuthenticatedThenLaunchLoginOrExecuteTask(authenticatedTask);
    },

    _init: function () {
        this._bindEvents();
        this._smsCheck();
    }
};

export default mobileAlert;
